import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { initSentry } from './lib/sentry'

// Sentry must init BEFORE any render — it hooks the global error and
// unhandledrejection listeners, and we want to capture crashes that
// happen during the first paint. No-op in dev builds (gated on PROD
// inside initSentry).
initSentry()

// Set initial theme before render to prevent flash
const stored = localStorage.getItem('placed-theme')
const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
if (stored === 'dark' || (!stored && prefersDark)) {
  document.documentElement.classList.add('dark')
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
